module.exports = __webpack_public_path__ + "static/working2-aea491a96f61ace84c81e5b87cb785e4.png";